<template lang="pug">
  .tickets-exchange
    SectionHeader(:header="header")

    .action__body
      .action__section
        .action__grid
          .action__form-field(v-for="(item, i) of items" :key="i")
            InputSmart(:item="item")

      .action__bottom
        Button(is-primary @click="onCheckButtonClick") Выкупить

</template>

<script>
import { mapActions } from 'vuex'
import InputSmart from '@/components/InputSmart/InputSmart'
import SectionHeader from '@/components/SectionHeader/SectionHeader'

export default {
  name: 'TicketsExchange',

  components: {
    InputSmart,
    SectionHeader,
  },

  data: () => ({
    items: {
      playerId: {
        title: 'ID игрока',
        value: null,
        type: 'number',
        placeholder: 'Введите ID',
      },

      ticketsCount: {
        title: 'Количество билетов',
        value: null,
        type: 'number',
        placeholder: 'Какое душа пожелает',
      },
    },
  }),

  computed: {
    gameName() {
      return this.$route.params.section
    },

    header() {
      return {
        title: `${this.$gameNameText(this.gameName)} / Выкуп билетов`,
        game: this.gameName,
      }
    },
  },

  created() {
    this.$forceUpdate()
  },

  methods: {
    ...mapActions('modal', ['showModal']),

    async onCheckButtonClick() {
      this.$loading.start()

      try {
        const playerId = this.items.playerId.value
        const ticketsCount = this.items.ticketsCount.value

        const { data } = await this.$axios.post(`/admin/user/${playerId}/tickets/exchange`, {
          tickets: ticketsCount,
        })

        if (data.data) {
          this.showModal({
            component: 'ModalMessage',
            data: {
              type: 'success',
              title: 'Успех',
              text: 'Билеты успешно выкуплены!',
            },
          })
        }
      } catch (e) {
        this.$error.handle(e)
      }

      this.$loading.finish()
    }
  },
}
</script>

<style lang="scss">
</style>
